export default __webpack_public_path__ + "static/media/Standard35.5e8df82b.png";